import { render, staticRenderFns } from "./knowledge.vue?vue&type=template&id=d2586ed8&scoped=true"
import script from "./knowledge.vue?vue&type=script&lang=js"
export * from "./knowledge.vue?vue&type=script&lang=js"
import style0 from "./knowledge.vue?vue&type=style&index=0&id=d2586ed8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2586ed8",
  null
  
)

export default component.exports